import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';

import { ValidationService } from '../../validation/register.validation';
import { matchOtherValidator } from '../../validation/password.validation';
import { ErrorMessagesComponent } from '../../validation/error-messages/error-messages';
import { UserService } from '../../services/user.service';

@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
	private registerForm;
	private error = "";
	public errorFontSize = ".9rem";
	private ready: boolean = true;
	private available: boolean = true;
	@ViewChild('emailpop') emailpop;
	@ViewChild('giftcodepop') giftcodepop;

	constructor(
		private formBuilder: FormBuilder,
		private userService: UserService,
		private router: Router
	) {
		this.formControlFunc();
	}

	ngOnInit() {
	}

	formControlFunc() {
		this.registerForm = this.formBuilder.group({
			//titleName:  [ '' , Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required]) ],      
			firstName: ['', Validators.compose([Validators.minLength(2), Validators.maxLength(16), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
			lastName: ['', Validators.compose([Validators.minLength(2), Validators.maxLength(16), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
			email: ['', Validators.compose([Validators.maxLength(70), ValidationService.emailValidator, Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'), Validators.required])],
			dataProtection: ['false', Validators.compose([Validators.required, ValidationService.agbValidator])],
			password: ['', Validators.compose([Validators.required, ValidationService.passwordValidator])],
			pwdConfirm: ['', [
				Validators.required,
				matchOtherValidator('password')
			]],
			useGiftcode: ['false'],
			giftcode: [''],
		})
	}


	async register() {
		this.ready = false;
		let giftCodeObj: any = null;
		let giftCodeValid = false;
		try {
			if (this.registerForm.get('useGiftcode').value === true && this.registerForm.get('giftcode').value.length !== 0) {
				giftCodeObj = await this.userService.getGiftcode(this.registerForm.get('giftcode').value);
				if (giftCodeObj.is_used || !giftCodeObj.is_active) {
					throw { origin: "giftcode", error: "Dieser Code wurde bereits verwendet" };
				} else {
					giftCodeValid = true;
				}
			}
			await this.userService.register(this.registerForm.get('firstName').value, this.registerForm.get('lastName').value, this.registerForm.get('email').value, this.registerForm.get('password').value);
			let user = await this.userService.login(this.registerForm.get('email').value, this.registerForm.get('password').value)
			if (giftCodeValid) {
				let bundleToBuy: any = await this.userService.updateGiftcode(user.session_token, giftCodeObj.giftcode, true);
				await this.userService.setBoughtVideo('bought_bundles', user.session_token, user.id, bundleToBuy.enables_packet);
				this.userService.setGifcodeHistory(user.id, user.session_token, giftCodeObj.giftcode, bundleToBuy.enables_packet)
			}

			localStorage.setItem('user', JSON.stringify(user));
			await this.userService.sendEmail(user.session_token, user.first_name, user.last_name, user.email);
			this.router.navigate(['dashboard'])

		} catch (error) {
			console.log(error);
			this.available = false;
			if (error.origin === "giftcode") {
				this.error = error.error;
				this.giftcodepop.show();
			} else {
				this.emailpop.show();
			}
			this.ready = true;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/guest/register/register.component.ts